// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question_pattern a,\n.question_pattern a:hover {\n  text-decoration: none; }\n\n.question_pattern .icon_block img {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); }\n", ""]);
// Exports
module.exports = exports;
